/**
 * Same LDAP/Scene7 employee-photo URL pattern PrimaryContacts.tsx's
 * generateAvatarUrl() and DACIContacts.tsx already use elsewhere in this
 * app. Those other call sites are left as their own inlined copies
 * deliberately (repointing them is unrelated cleanup, out of scope for
 * this feature) - this helper only unifies the copy that lives inside
 * Review & Approval, so every avatar-rendering cell added to this feature
 * (RequestorCell today, the approver cell later) shares one definition
 * instead of each inlining its own. Avatar's own onError fallback
 * (DefaultContactIcon) already handles a person with no photo on file,
 * same as those other call sites.
 */
export function getEmployeePhotoUrl(uid: string): string {
  return `https://s7d2.scene7.com/is/image/IMGDIR/${uid}`;
}
